var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-row',[_c('v-col',[_c('div',{staticClass:"text-h4 text-sm-h2 pt-8 pb-4",attrs:{"color":"primary"}},[_vm._v(_vm._s(_vm.heading))])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }